import { AGeneralActionCreator } from '../../core/classes/general-action-creator.abstract';
import {
  ITablelistClear,
  ITablelistIds,
  ITablelistStateActionConfigTemplate,
  ITablelistStateActionPageIdsTemplate,
  ITablelistStateListItem,
  ITablelistStateIdentifierData,
  TABLELIST_ACTIONS
} from '../interfaces';

export class InitTablelistAction extends AGeneralActionCreator {
  readonly type = TABLELIST_ACTIONS.INIT;

  constructor() {
    super(null);
  }
}

export class ClearTablelistAction extends AGeneralActionCreator<ITablelistClear> {
  readonly type = TABLELIST_ACTIONS.CLEAR;

  constructor(payload: ITablelistClear) {
    super(payload);
  }
}

export class ClearIdsTablelistAction extends AGeneralActionCreator<ITablelistClear> {
  readonly type = TABLELIST_ACTIONS.CLEAR_IDS;

  constructor(payload: ITablelistClear) {
    super(payload);
  }
}

export class ClearDataTablelistAction extends AGeneralActionCreator<ITablelistClear> {
  readonly type = TABLELIST_ACTIONS.CLEAR_DATA;

  constructor(payload: ITablelistClear) {
    super(payload);
  }
}

export class FetchTablelistConfigurationTemplateAction extends AGeneralActionCreator<ITablelistStateActionConfigTemplate> {
  readonly type = TABLELIST_ACTIONS.SET_CONFIG_TEMPLATE;

  constructor(payload: ITablelistStateActionConfigTemplate) {
    super(payload);
  }
}

export class SetIdsTablelistAction extends AGeneralActionCreator<ITablelistIds> {
  readonly type = TABLELIST_ACTIONS.SET_IDS;

  constructor(payload: ITablelistIds) {
    super(payload);
  }
}

export class UpdateIdsTablelistAction extends AGeneralActionCreator<ITablelistIds> {
  readonly type = TABLELIST_ACTIONS.UPDATE_IDS;

  constructor(payload: ITablelistIds) {
    super(payload);
  }
}

export class FetchTablelistPageAction extends AGeneralActionCreator<ITablelistStateActionPageIdsTemplate> {
  readonly type = TABLELIST_ACTIONS.SET_PAGE;

  constructor(payload: ITablelistStateActionPageIdsTemplate) {
    super(payload);
  }
}

export class FetchTablelistPageDataAction extends AGeneralActionCreator {
  readonly type = TABLELIST_ACTIONS.SET_PAGE_DATA;

  constructor(payload: any) {
    super(payload);
  }
}

export class SetEntitiesAmountAction extends AGeneralActionCreator {
  readonly type = TABLELIST_ACTIONS.SET_ENTITIES_AMOUNT;

  constructor(resourceName: string, amount: number) {
    super({ resourceName, amount });
  }
}

export class SetIdentifierDataAction extends AGeneralActionCreator<ITablelistStateIdentifierData> {
  readonly type = TABLELIST_ACTIONS.SET_IDENTIFIER_DATA;

  constructor(payload : ITablelistStateIdentifierData){
    super(payload)
  }

}

export class ClearIdentifierDataTablelistAction extends AGeneralActionCreator<ITablelistClear> {
  readonly type = TABLELIST_ACTIONS.CLEAR_IDENTIFIER_DATA;

  constructor(payload: ITablelistClear) {
    super(payload);
  }
}
export type TTableListActions = InitTablelistAction |
  FetchTablelistConfigurationTemplateAction |
  FetchTablelistPageAction |
  FetchTablelistPageDataAction |
  ClearIdsTablelistAction |
  ClearDataTablelistAction |
  ClearTablelistAction |
  UpdateIdsTablelistAction |
  SetIdsTablelistAction |
  SetEntitiesAmountAction |
  SetIdentifierDataAction |
  ClearIdentifierDataTablelistAction;